import type { CoreModuleConfig } from '../../types/modules/core';

export const DEFAULT_CORE_MODULE_CONFIG: CoreModuleConfig = {
  enabled: true,

  pageView: {
    enabled: true,
    trackInitialPageView: true,
    spa: true,
    dedupeMs: 2000,
  },

  visitor: {
    enabled: true,
    persistence: 'cookie_localStorage',
    renew: false,
  },

  session: {
    enabled: true,
    ttlMs: 10800000,
    renewOnActivity: true,
    renewOnPageView: true,
  },

  fingerprint: {
    enabled: true,
    mode: 'light',
    cache: true,
  },

  consent: {
    enabled: false,
    required: false,
    waitForConsent: false,
  },

  dedupe: {
    enabled: true,
    windowMs: 2000,
  },

  coordination: {
    enabled: true,
    leaderElection: true,
    broadcastChannel: true,
  },

  ordering: {
    enabled: true,
    preserveOrder: true,
  },

  urlContext: {
    enabled: false,
  },
};
